import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { IVrContent } from './vr-content-card.model';

/** Tarjeta enriquecida de una experiencia de realidad virtual. */
@Component({
  selector: 'app-vr-content-card',
  imports: [LazyLoadImageModule],
  templateUrl: './vr-content-card.component.html',
  styleUrl: './vr-content-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VrContentCard {
  readonly content = input.required<IVrContent>();
  readonly open = output<IVrContent>();

  protected readonly typeLabel = computed(() =>
    this.content().type === 'tour-360' ? 'Recorrido 360°' : 'Video VR',
  );
}
